import styled, { css } from "styled-components";
import { IStyleProps } from "./interfaces";

export const Progress = styled.div`
    display: flex;
    /* stylelint-disable */
    -webkit-padding-start: 0;
    /* stylelint-enable */
    align-items: center;
    margin: 6px 64px;
`;

export const Point = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    border: 3px solid ${p => p.theme.c.dark};
    background-color: ${p => p.theme.c.snow};
    box-sizing: border-box;
    border-radius: 20px;
    height: 40px;
    position: relative;
    cursor: pointer;
    z-index: 10;

    .Label {
        position: absolute;
        top: -3px;
        left: 0;
        background-color: ${p => p.theme.c.active};
        border-radius: 10px;
        color: white;
        border: 3px solid ${p => p.theme.c.grey7};
        white-space: nowrap;
        font-size: 22px;
        font-weight: 300;
        margin-left: 50%;
        transform: translateX(-50%);
        padding: 4px 8px;
        opacity: 0;
        transition: 0.2s;
    }

    &:hover {
        .Label {
            display: block;
            opacity: 1;
        }
    }

    &.Selectable {
        background-color: ${p => p.theme.c.active};
        color: ${p => p.theme.c.snow};
    }

    &.Active {
        font-weight: bold;
        text-decoration: underline;
        .Label {
            display: block;
            opacity: 1;
        }
    }
`;

export const Tick = styled.div`
    position: absolute;
    .i-tick {
        color: ${p => p.theme.c.white};
        font-weight: 300;
        font-size: 24px;
    }
`;

export const Line = styled.div`
    flex: 1;
    background-color: ${p => p.theme.c.dark};
    height: 4px;
`;

export const ScoreEditorWrapper = styled.div`
    height: calc(100% - 16px);
`;

const Button = styled.button`
    bottom: -6px;
    position: absolute;
`;

export const Back = styled(Button)`
    left: 10px;
`;

export const Next = styled(Button)`
    right: 10px;
`;

export const HelpWrapper = styled.div`
    display: inline-block;
    position: relative;
    &:hover {
        .HelpDescription {
            display: block;
        }
    }
`;

export const Help = styled.div`
    background-color: ${p => p.theme.c.info};
    width: 28px;
    border-radius: 14px;
    margin: 0 0 0 6px;
    text-align: center;
`;

export const HelpDescription = styled.div<IStyleProps>`
    position: absolute;
    background-color: ${p => p.theme.c.info};
    width: 240px;
    padding: 8px;
    white-space: normal;
    top: 40px;
    left: -90px;
    z-index: 100;
    display: none;
    font-size: 20px;
    border-radius: 7px;
    box-shadow: 0 0 8px 0 ${p => p.theme.c.blackShadow3};
    ul {
        padding-left: 20px;
        margin: 0;
    }

    ${p =>
        p.left &&
        css`
            left: -210px;
        `}
`;